// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__KKY0Y","modal":"InfoModal_modal__ugpPo","viddo_modal":"InfoModal_viddo_modal__TxXXt","btn_main":"InfoModal_btn_main__hypTM"};